<template>
	<div class="ticketIndex">
		<back-to></back-to>
		<!-- 搜索栏 -->
		<section class="ticketTop">
			<div class="search" @click="$router.push({ path: '/search'})">
				<img src="https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/sweetour-h5_retailstore_search.png"
					alt="">
				<span class="placeholder">输入目的地、景点或关键词</span>
			</div>
			<div class="cityList">
				<div class="city_left">
					<span v-if="unfold?index >=0:index < 4" :class="region == item.keyword?'city_active':''"
						v-for="(item, index) in cityList" :key="index"
						@click="region=item.keyword,page=1,listItem_ticket=[],getList(true)">{{item.title}}</span>
				</div>
				<div v-if="cityList.length > 4" class="city_right" @click="unfold = !unfold">
					<p type="" :class="unfold?'arrow-down':'arrow-up'" />
				</div>
			</div>
		</section>
		<section class="list">
			<div class="searchList">
				<div class="search-tab">
					<span v-if="unfolds?index >=0:index < 4" :class="current == item.param?'active':''"
						v-for="(item, index) in tabList" :key="index"
						@click="current=item.param,page=1,listItem_ticket=[],getList(true)">{{item.title}}</span>
				</div>
				<div v-if="tabList.length > 4" class="city_right unfolds" @click="unfolds = !unfolds">
					<p type="" :class="unfolds?'arrow-down':'arrow-up'" />
				</div>
			</div>
			<van-list class="listItems" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
				:immediate-check="false">
				<div class="listItem_ticket" v-for="(item, index) in data_product_array" :key="index"
					@click="item.price > 0 ? nextTick(item.id) : ''">
					<img v-lazy="item.imageUrl" />
					<div class="listItem_ticket_con">
						<div class="listItem_ticket_title">{{item.title}}</div>
						<div class="listItem_price">
							<div v-if="item.price !=0" class="listItem_ticket_price">
								<p>￥</p>
								<label for="">{{item.price}}</label>
								<p>起</p>
							</div>
							<div class="listItem_ticket_type" v-if="item.price == 0">敬请期待</div>
							<div class="listItem_ticket_type">销量 {{item.num}}</div>
						</div>
					</div>
				</div>
			</van-list>
		</section>
	</div>
</template>

<script>
	import List from '@/components/List.vue'
	import BackTo from "@/components/BackTo";
	export default {
		name: 'ticketIndex',
		components: {
			List,
			BackTo
		},
		data() {
			return {
				cityList: [],
				tabList: [],
				region: '',
				current: 0,
				unfold: false,
				unfolds: false,
				loading: false,
				finished: false,
				page: 1,
				data_product_array: []
			}
		},
		created() {
			this.getJqCity()
		},
		methods: {
			// 景点门票城市
			getJqCity() {
				this.$get(this.$login + '/api/GetAppMenuList', {}).then(res => {
					var appDta = res.data.find(item => item.areaNo === 17).items[0].items
					var tabList = res.data.find(item => item.areaNo === 18).items[0].items
					// console.log(appDta)
					// console.log(111)
					tabList.unshift({
						'title': "全部",
						'param': 0
					})
					this.cityList = appDta
					this.region = appDta[0].keyword
					this.tabList = tabList
					this.current = tabList[0].param
					this.getList(true)
				})
			},
			nextTick(id) {
				this.$router.push({
					path: '/detail',
					query: {
						id: id
					}
				})
			},
			onLoad() {
				setTimeout(() => {
					this.loading = false;
					this.page = this.page + 1
					this.getList()
				}, 500);
			},
			getList(e) {
				this.$post(this.$login + '/api/services/app/NewNearTravel/GetNearTravel_List', {
					"keyWord": this.region,
					"pageIndex": this.page,
					"pageSize": 10,
					"organizationId": this.$organizationId,
					"isZeroShow": false,
					"themeId": Number(this.current)
				}).then(res => {
					console.log(res)
					if (e) {
						this.data_product_array = res.result.tag.tagProductList
					} else {
						this.data_product_array = this.data_product_array.concat(res.result.tag.tagProductList)
					}
					if (res.result.tag.tagProductList.length < 10) {
						this.finished = true;
					}
				})
			}
		}
	}
</script>

<style>
	.ticketIndex {
		background-color: #f5f5f5;
	}

	.ticketTop {
		width: 100%;
		background-color: #fff;
		padding: 20px 26px;
		box-sizing: border-box;
		position: sticky;
		top: 0;
		z-index: 999;
	}

	.search {
		height: 68px;
		border-radius: 34px;
		background-color: #f2f2f2;
		color: #ccc;
		font-size: 28px;
		display: flex;
		align-items: center;
		width: 100%;
		padding: 0 28px;
		box-sizing: border-box;
	}

	.search img {
		width: 28px;
		height: 28px;
		margin-right: 20px;
	}

	.cityList {
		width: 100%;
		display: flex;
		justify-content: space-between;
		margin-top: 10px;
	}

	.city_left {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		flex-wrap: wrap;
		gap: 14px;
		flex: 1;
		font-size: 30px;
		color: #293243;
		z-index: 33;
	}

	.city_left span {
		width: 100%;
		text-align: center;
		margin-top: 20px;
	}

	.city_active {
		position: relative;
		font-weight: bold;
		font-size: 34px;
	}

	.city_active::after {
		content: "";
		position: absolute;
		bottom: -4px;
		left: 50%;
		z-index: -1;
		transform: translateX(-50%);
		width: 71px;
		height: 15px;
		background: linear-gradient(90deg, #FFC98B 0%, #FF7303 100%);
		border-radius: 10px;
	}

	.city_right {
		width: 31px;
		height: 31px;
		background: linear-gradient(180deg, #FF7102 0%, #FFA843 100%);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 24px;
	}

	.unfolds {
		margin-top: 10px !important;
	}

	.arrow-up {
		height: 12px;
		width: 12px;
		border-width: 0 3px 3px 0;
		border-style: solid;
		color: #ffffff;
		/* 根据这个来控制箭头方向 */
		transform: rotate(45deg);
		margin-bottom: 8px;
	}

	.arrow-down {
		height: 12px;
		width: 12px;
		border-width: 0 3px 3px 0;
		border-style: solid;
		color: #ffffff;
		/* 根据这个来控制箭头方向 */
		transform: rotate(-135deg);
		margin-top: 8px;
	}

	.list {
		width: 100%;
		background-color: #f5f5f5;
		padding: 20px;
		box-sizing: border-box;
	}

	.searchList {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.search-tab {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		flex-wrap: wrap;
		flex: 1;
		z-index: 33;
		gap: 20px;
		margin-right: 20px;
	}

	.search-tab span {
		width: 100%;
		height: 54px;
		background: #FFFFFF;
		border-radius: 31px;
		/* border: 1rpx solid #CCCCCC; */
		font-size: 28px;
		color: #666666;
		line-height: 54px;
		text-align: center;
	}

	.active {
		background: #1B78F6 !important;
		color: #ffffff !important;
		border: 0 !important;
	}

	.unfolds {
		margin-top: 10rpx !important;
	}


	.listItems {
		width: 100%;
		display: flex;
		box-sizing: border-box;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-top: 20px;
	}

	.listItem_ticket {
		width: 346px;
		margin-bottom: 20px;
		background-color: #FFFFFF;
		/* box-shadow: 0rpx 3rpx 6rpx 1rpx rgba(0, 0, 0, 0.16); */
		border-radius: 20px;
	}

	.listItem_ticket img {
		width: 346px;
		height: 360px;
		border-radius: 20px 20px 0 0;
	}

	.listItem_ticket_con {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding: 10px 14px 20px 14px;
		height: 156px;
		box-sizing: border-box;
	}

	.listItem_ticket_title {
		display: -webkit-box;
		overflow: hidden;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		color: #333333;
		font-size: 26px;
		line-height: 36px;
	}

	.listItem_ticket_theme {
		width: 108px;
		height: 40px;
		background: #F4F5F7;
		border-radius: 7px;
		font-size: 20px;
		color: #888888;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: auto;
		margin-bottom: 7px;
	}

	.listItem_ticket_cfd {
		font-size: 20px;
		color: #999999;
		line-height: 32px;
		margin: 10px 0 27px 0;
	}

	.listItem_price {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.listItem_ticket_price {
		color: #F94C00;
		font-size: 36px;
		font-weight: bold;
		display: flex;
		align-items: baseline;
	}

	.listItem_ticket_type {
		font-size: 22px;
		color: #999999;
	}

	.listItem_ticket_price p:first-child {
		font-size: 22px;
		padding-bottom: 4px;
	}

	.listItem_ticket_price p:last-child {
		color: #999999;
		font-size: 20px;
		font-weight: normal;
		padding-bottom: 4px;
		padding-left: 4px;
	}
</style>